import React, { useContext, useState } from "react";
import TrainerContext from "../../../context/trainerContext/TrainerContext";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { adminService } from "../../../api/services";
import makeRequest from "../../../api";
import { toast } from "react-toastify";

const Profile = () => {
  const { getTrainerState } = useContext(TrainerContext);
  const trainerData = getTrainerState();

  const [inputData, setInputData] = useState({
    oldPassword: "",
    password: "",
  });
  const [viewPassword, setViewPassword] = useState(false);

  const changePassword = async () => {
    try {
      const res = await makeRequest(
        adminService.updateTrainerPassword({
          ...inputData,
          category: trainerData.trainerCategory,
          trainerId: trainerData.trainerId,
        })
      );

      if (!res?.data?.status) {
        toast.error(res?.data?.error);
      } else {
        toast.success("Password updated successfully!");
      }
    } catch (err: any) {
      toast.error("Something went wrong");
    }
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (inputData.oldPassword !== "" && inputData.password !== "")
      changePassword();
  };

  return (
    <div className="">
      <div className="card">
        <div className="card-body">
          <div className="d-flex flex-column align-items-center text-center">
            {!!trainerData?.trainerImage?.length && (
              <img
                src={trainerData?.trainerImage}
                alt="trainer profile"
                className="rounded-circle"
                width="200"
                height="200"
              />
            )}
            <div className="mt-3">
              <h4>{trainerData?.trainerName}</h4>
              <p className="text-secondary mb-1">
                <strong>
                  {trainerData?.trainerCategory} | {trainerData?.trainerEmail}
                </strong>
              </p>
              <p className="text-muted font-size-sm">
                {trainerData?.trainerDescription}
              </p>
            </div>
          </div>
          <div className="w-50 mt-5">
            <h6 className="mb-3">
              <strong>Change password</strong>
            </h6>
            <form onSubmit={handleSubmit}>
              <div className="form-goup mb-3 position-relative">
                <input
                  type={viewPassword ? "text" : "password"}
                  name="oldPassword"
                  id="name"
                  className="form-control"
                  placeholder="Enter old password"
                  value={inputData.oldPassword}
                  onChange={handleChange}
                  required
                />
                <span
                  className="position-absolute"
                  style={{
                    top: "50%",
                    right: "0",
                    transform: "translate(-100%, -50%)",
                  }}
                  onClick={() => setViewPassword((prev: any) => !prev)}
                >
                  {!viewPassword ? <FaEye /> : <FaEyeSlash />}
                </span>
              </div>
              <div className="form-goup mb-3 position-relative">
                <input
                  type={viewPassword ? "text" : "password"}
                  name="password"
                  id="value"
                  className="form-control"
                  placeholder="Enter new password"
                  value={inputData.password}
                  onChange={handleChange}
                  required
                />
                <span
                  className="position-absolute"
                  style={{
                    top: "50%",
                    right: "0",
                    transform: "translate(-100%, -50%)",
                  }}
                  onClick={() => setViewPassword((prev: any) => !prev)}
                >
                  {!viewPassword ? <FaEye /> : <FaEyeSlash />}
                </span>
              </div>
              <button className="btn btn-sm btn-outline-success">
                Change password
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
